// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/number-pronunciation.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/number-pronunciation/number-pronunciation.js';

mount([g0]);
